<template>
  <div>
    <!-- <section class="inner_banner"></section> -->
    <section class="exchange_effect">
      <div class="container">
        <h3>Trades</h3>
        <div class="exchange_effect_table">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <!-- <th width="33.3333%">Liquidity pool</th>
                  <th width="33.3333%">value</th>
                  <th width="33.3333%">Platform fee</th> -->
                  <th width="20%">Tx</th>
                  <th width="20%">Sender</th>
                  <th width="20%">In</th>
                  <th width="20%">Out</th>
                  <th width="5%">Amt</th>
                  <th width="5%">Fee</th>
                  <th width="5%">Supplier</th>
                  <th width="5%">Inc. Pool</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="trade in trades" v-bind:key="trade.transaction_hash">
                  <td>
                    <code>
                      <a
                        :href="`https://etherscan.io/tx/${trade.id}`"
                        target="_blank"
                      >
                        {{ trade.transaction_hash | toShortAccount }}
                      </a>
                    </code>
                  </td>
                  <td class="code">
                    <code>{{ trade.sender | toShortAccount }}</code>
                  </td>
                  <td>
                    {{ trade.token_in }}
                  </td>
                  <td>
                    {{ trade.token_out }}
                  </td>
                  <td>
                    {{ trade.amount }}
                  </td>
                  <td>
                    {{ trade.total_fee }}
                  </td>
                  <td>
                    {{ trade.supplier_fee }}
                  </td>
                  <td style="background: transparent">
                    {{ trade.pool_fee }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import _ from "lodash";
import { gql } from "apollo-boost";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  computed: {
    ...mapGetters(["contracts", "erc20TokenContract", "account"]),
    trades() {
      if (this.swaps && this.swaps.length > 0) {
        return _.orderBy(this.swaps, ["timestamp"], ["desc"]).map((trade) => ({
          id: trade.id,
          transaction_hash: this.$options.filters.toShortAccount(trade.id),
          sender: this.$options.filters.toShortAccount(trade.sender),
          token_in: trade.tokenInName,
          token_out:
            trade.tokenOutName,
          amount: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.amount)
          )}`,
          total_fee: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.fee)
          )}`,
          supplier_fee: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.supplierFee)
          )}`,
          pool_fee: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.incentivePoolFee)
          )}`,
        }));
      }

      return [];
    },
  },
  data() {
    return {};
  },
  apollo: {
    swaps: {
      query: gql(`query {
                swaps {
                    id
                    tokenInName
                    tokenOutName
                    amount
                    sender
                    timestamp
                    fee
                }
            }`),
      pollInterval: 2000,
    },
  },
  methods: {},
  async mounted() {},
  beforeDestroy() {},
};
</script>
